export default "__VITE_ASSET__DNqeuv6F__"